import { render, staticRenderFns } from "./ViewMoneyAccount.vue?vue&type=template&id=31d10495&"
import script from "./ViewMoneyAccount.vue?vue&type=script&lang=js&"
export * from "./ViewMoneyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports